import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Reveal from './Reveal';
import { azure } from '../theme';

export function Section({ id, children, sx, containerProps, ...rest }) {
  return (
    <Box
      component="section"
      id={id}
      sx={{ position: 'relative', py: { xs: 10, md: 14 }, ...sx }}
      {...rest}
    >
      <Container maxWidth="lg" {...containerProps}>
        {children}
      </Container>
    </Box>
  );
}

export function Eyebrow({ children, sx }) {
  return (
    <Typography
      variant="overline"
      component="p"
      sx={{
        color: azure[300],
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        mb: 2,
        '&::before': {
          content: '""',
          display: 'inline-block',
          width: 34,
          height: 2,
          borderRadius: 1,
          background: `linear-gradient(90deg, ${azure[400]}, transparent)`,
        },
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export function SectionHeading({ eyebrow, title, lead, maxWidth = 680 }) {
  return (
    <Reveal sx={{ mb: { xs: 6, md: 8 } }}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <Typography variant="h2" component="h2" sx={{ maxWidth: 760 }}>
        {title}
      </Typography>
      {lead && (
        <Typography variant="subtitle1" sx={{ mt: 2.5, maxWidth, color: 'text.secondary' }}>
          {lead}
        </Typography>
      )}
    </Reveal>
  );
}
